<template>
  <WebccBreadcrumb v-if="!$params.iframe" :items="items" class="py-3" />
</template>

<script setup lang="ts">
const props = defineProps<{ block: Block<BreadcrumbsBlockContent> }>()

const items = computed(() => {
  return props.block.content.links.map((link) => {
    return {
      target: link.href,
      title: link.label,
      text: link.label,
      content: link.label,
    }
  })
})
</script>
